import { ApiError } from "./ApiError";
import type { ApiErrorBody, ApiErrorCode } from "./apiErrorCodes";

export type ApiErrorWithCode<C extends ApiErrorCode> = ApiError & {
  readonly code: C;
  readonly body: Extract<ApiErrorBody, { error: C }>;
};

// Сужает ошибку до конкретного кода с типизированными `params`:
// `if (hasApiErrorCode(error, "analysis_limit_reached")) error.body.params.resets_at`.
export const hasApiErrorCode = <C extends ApiErrorCode>(
  error: unknown,
  code: C,
): error is ApiErrorWithCode<C> => error instanceof ApiError && error.code === code;
